import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function StageFooter({
  stage,
  totalStages,
  onBack,
  onNext,
  nextLabel,
  nextDisabled,
  hint,
}) {
  const isLast = stage >= totalStages - 1;
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 12,
        zIndex: 10,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        boxShadow: (t) => t.customShadows?.z1 || 1,
        px: 2.5,
        py: 1.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.25,
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="center">
        {stage > 0 && (
          <Button variant="outlined" color="inherit" startIcon={<ArrowBackIcon />} onClick={onBack}>
            Back
          </Button>
        )}
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {hint || ''}
        </Typography>
      </Stack>
      {!isLast && (
        <Button
          variant="contained"
          color="primary"
          endIcon={<ArrowForwardIcon />}
          onClick={onNext}
          disabled={nextDisabled}
        >
          {nextLabel || `Next: Stage ${stage + 2}`}
        </Button>
      )}
    </Box>
  );
}
